export default __webpack_public_path__ + "static/media/10.070550d9.png";